module.exports = __webpack_public_path__ + "static/scale-model-of-sleeping-beauty-castle-in-fullerton-california-08108013947d36749d3505b150afc4d9.png";